var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiferay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2837_2052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2837_2052)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -3,
    width: 42,
    height: 42,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2837_2052",
    transform: "translate(-0.369565 -0.369565) scale(0.0217391)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2837_2052",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAASFBMVEUAAAD////////////////8/Pz////////9/f3////////////+/v7+/v7////+/v7+/v7+/v7////+/v7////+/v7+/v7+/v7GPAxrAAAAF3RSTlMABwtdXl9fYI+QkZK9vr7a29/f4OD9/phyfFwAAAABYktHRAH/Ai3eAAAA3ElEQVRYw+2XzQ6CMBAG+VNaEAFr5f3fVIz20E1KPneboGHnsvQyl52ktCgURVGU/6WqTQdgThXouywgA2ZsFpgGEhpcaCFhhwv7PYUPN604TydbeC9f3+VMJ1s4vQ8jnSrEhe6zBDrZQn8bV2ZPZ7YOgyM6SzoMwugsWUoQRmcVftVhEDruUlL9RWdOh7Q/cYe0P3GHdBniLR9ImOpP3CHtj91hqj92h6n+2B2mlsFeyoGFm/czR7h5P+/6w5lRmP2nvcaFLfbwGVDfFX1KnW0PYNGnmaIoivKTPAGJAnZandmh3AAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiferay);
export default __webpack_public_path__ + "static/media/liferay.bd1b9f85ce5044d59078bdf33a6c3370.svg";
export { ForwardRef as ReactComponent };